<template>
  <div id="app" class="lao-content">
    <transition
      name="page"
      mode="out-in"
      @after-enter="refreshLandingAnimations"
    >
      <component :is="layout">
        <router-view />
      </component>
    </transition>
    <ConfirmDialog />
  </div>
</template>
<script>
const default_layout = "default";
import { mapGetters } from "vuex";
import { scrollAnimationMixin } from "@/mixin/scrollAnimation.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
export default {
  components: {
    ConfirmDialog,
  },
  metaInfo() {
    return {
      title: this.$t(this.$route.name) + " - PosSmart",
      meta: [
        {
          name: "description",
          content: "PosSmart",
        },
        {
          property: "og:title",
          content: `${this.$route.name} - PosSmart`,
        },
        { property: "og:site_name", content: "Epiloge" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  mixins: [scrollAnimationMixin],
  data: () => ({}),

  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    layout() {
      return this.$route.meta.layout || default_layout;
    },
    isLanding() {
      return this.$route.path === "/";
    },
  },
  watch: {
    "$route.path"(toPath) {
      if (toPath !== "/") return;
      this.refreshLandingAnimations();
    },
  },
  methods: {
    refreshLandingAnimations() {
      if (!this.isLanding) return;

      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          if (!this.isLanding) return;

          if (typeof this.refreshScrollAnimations === "function") {
            this.refreshScrollAnimations();
          }
        });
      });
    },
  },
};
</script>

<style>
/* Apply dark OLED theme only to landing page */
#app.lao-content .v-application {
  background: var(--bg-primary);
}

#app.lao-content .theme--light .v-btn--has-bg {
  background-color: var(--bg-glass);
  color: var(--text-primary);
}

#app.lao-content .theme--light .v-btn--has-bg:hover {
  background-color: var(--bg-glass-hover);
}
</style>
